// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomCollapse_custom_collapse__hSwB4.ant-collapse {
    /* border: none !important; */
    -webkit-user-select: none;
            user-select: none;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-header {
    display: flex;
    justify-content: flex-start !important;
    align-items: center !important;
    width: 100%;
    height: 40px;
    padding: 0 !important;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 6px !important;
    position: sticky !important;
    top: 0px;
    z-index: 1000;
    background-color: #000;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-header:hover {
    background-color: #262626;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-header:active {
    background-color: #404040;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-item {
    /* border-bottom: none !important; */
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-content {
    /* border: none !important; */
    background-color: transparent;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-content-box {
    padding: 0 !important;
}

.CustomCollapse_custom_collapse__hSwB4 .ant-collapse-header .ant-collapse-expand-icon {
    padding-inline-end: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/common/CustomCollapse/index.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAE7B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".custom_collapse:global(.ant-collapse) {\n    /* border: none !important; */\n    user-select: none;\n}\n\n.custom_collapse :global(.ant-collapse-header) {\n    display: flex;\n    justify-content: flex-start !important;\n    align-items: center !important;\n    width: 100%;\n    height: 40px;\n    padding: 0 !important;\n    margin-bottom: 5px;\n    cursor: pointer;\n    border-radius: 6px !important;\n    position: -webkit-sticky !important;\n    position: sticky !important;\n    top: 0px;\n    z-index: 1000;\n    background-color: #000;\n}\n\n.custom_collapse :global(.ant-collapse-header:hover) {\n    background-color: #262626;\n}\n\n.custom_collapse :global(.ant-collapse-header:active) {\n    background-color: #404040;\n}\n\n.custom_collapse :global(.ant-collapse-item) {\n    /* border-bottom: none !important; */\n}\n\n.custom_collapse :global(.ant-collapse-content) {\n    /* border: none !important; */\n    background-color: transparent;\n}\n\n.custom_collapse :global(.ant-collapse-content-box) {\n    padding: 0 !important;\n}\n\n.custom_collapse :global(.ant-collapse-header .ant-collapse-expand-icon) {\n    padding-inline-end: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom_collapse": `CustomCollapse_custom_collapse__hSwB4`
};
export default ___CSS_LOADER_EXPORT___;
